import React from 'react';
import { Button, Grid, Typography} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import FormInput from './FormInput';
import CustomTextField from './CustomTextField';

const AddressForm = ({checkoutToken, next}) => {
  const methods = useForm ();

  return (
    <div>
      <Typography variant="h6" gutterBottom> Direccion de envio </Typography>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit((data) => next({ ...data }))}>
          <Grid container spacing={3}>
            <FormInput required name='firstName' label ='Nombre' />
            <FormInput required name='lastName' label ='Apellidos' />
            <FormInput required name='address1' label ='Calle y numero' />
            <FormInput required name='address2' label ='Cruzamientos' />
            <FormInput required name='address3' label ='Colonia' />
            <FormInput required name='phone' label ='Telefono' />
            <FormInput required name='email' label ='Correo Electronico' />
            <FormInput required name='reference' label ='Referencias domicilio' />
            <CustomTextField name="comments" label='Comentarios sobre el pedido'/>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              
          </Grid> */}

          <br />
          <div style={{display:'flex', justifyContent:'space-between'}}>
            <Button component={Link} to="/cart" variant="outlined">Regresar al carrito</Button>
            <Button type="submit" variant="contained" color="primary">Siguiente</Button>
          </div>

        </form>
      </FormProvider>
    </div>
  )
}

export default AddressForm;
